import { render, staticRenderFns } from "./Clasesv2.vue?vue&type=template&id=360624a2"
import script from "./Clasesv2.vue?vue&type=script&lang=js"
export * from "./Clasesv2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports